import React, { useEffect, useRef, useState } from 'react';
import { OverlayTrigger, Tooltip, TooltipProps } from 'react-bootstrap';
import { Placement } from 'react-bootstrap/esm/types';

const CustomTooltip = ({ overlayContent, placement = 'auto', children, scrollElement = null }: { overlayContent: React.ReactNode; placement: Placement; children: React.ReactNode; scrollElement: HTMLElement | null }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const triggerRef = useRef<HTMLButtonElement | null>(null);

  // Hide tooltip when scrolling
  useEffect(() => {
    const handleScroll = () => {
      if (showTooltip) {
        setShowTooltip(false);
      }
    };

    if(scrollElement){
      scrollElement.addEventListener('scroll', handleScroll, { passive: true });
    } else{
      window.addEventListener('scroll', handleScroll, { passive: true });
    }

    return () => {
      if(scrollElement){
        scrollElement.removeEventListener('scroll', handleScroll);
      } else{
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [showTooltip]);

  const renderTooltip = (props: TooltipProps) => (
    <Tooltip {...props}>
      {overlayContent}
    </Tooltip>
  );

  return (
    <>
      <OverlayTrigger
        placement={placement as Placement}
        overlay={renderTooltip}
        show={showTooltip}
      >
        <span
          ref={triggerRef}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          onTouchStart={() => setShowTooltip(true)}
          onTouchEnd={() => setShowTooltip(false)}
          className='custom-tooltip-wrapper'
          style={{ padding: '0px' }}
        >
            {children}
        </span>
      </OverlayTrigger>
    </>
  );
};

export default CustomTooltip;
